import { request } from "./client.js";
export const previewProductImport = async (file) => {
    const form = new FormData();
    form.append('file', file);
    return (await request('/api/v1/import/products/preview', {
        method: 'POST',
        body: form,
    }));
};
export const applyProductImport = async (file, decisions) => {
    const form = new FormData();
    form.append('file', file);
    form.append('decisions', JSON.stringify(decisions));
    return (await request('/api/v1/import/products/apply', {
        method: 'POST',
        body: form,
    }));
};
export const previewProductRecode = async (file) => {
    const form = new FormData();
    form.append('file', file);
    return (await request('/api/v1/import/products/recode/preview', {
        method: 'POST',
        body: form,
    }));
};
export const applyProductRecode = async (file, categories = []) => {
    const form = new FormData();
    form.append('file', file);
    form.append('decisions', JSON.stringify({ priceListId: null, categories }));
    return (await request('/api/v1/import/products/recode/apply', {
        method: 'POST',
        body: form,
    }));
};
const partyImportForm = (file, decisions) => {
    const form = new FormData();
    /*
     * As decisões vão ANTES do arquivo.
     *
     * O `@fastify/multipart` entrega as partes na ordem em que chegam, e o
     * servidor lê os campos junto do arquivo; um campo que só aparece depois do
     * arquivo de 200 KB chega tarde demais para influenciar a leitura.
     */
    form.append('decisions', JSON.stringify(decisions));
    form.append('file', file);
    return form;
};
export const previewPartyImport = async (file, decisions) => (await request('/api/v1/import/parties/preview', {
    method: 'POST',
    body: partyImportForm(file, decisions),
}));
export const applyPartyImport = async (file, decisions) => (await request('/api/v1/import/parties/apply', {
    method: 'POST',
    body: partyImportForm(file, decisions),
}));
//# sourceMappingURL=import.js.map